import React, { Component } from 'react';
import TableHeader from './tableheader';
import TableBody from './tablebody';

class Table extends Component {
  render() {
    // eslint-disable-next-line
    const { columns, sortColumn, onSort, data } = this.props;

    return (
      <table className="table table-dark striped responsive-table">
        <TableHeader
          columns={columns}
          sortColumn={sortColumn}
          /*onSort={onSort}*/
        />
        <TableBody data={data} columns={columns} />
      </table>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/table.js